import React from 'react'
import { TablePlugin } from '../../../../plugins/components/TablePlugin'
import { useGetComplicationsQuery } from '../../../../services/rtk-query/clinicalApi'

export const Lista = ({ columns }) => {
  const { data, isFetching } = useGetComplicationsQuery()
  return (
    <>
      <TablePlugin data={data ?? []} columns={columns} isFetching={isFetching} />
    </>
  )
}
